var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakedNfts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.1375C29.8875 14.9062 28.0312 13.125 25.7812 13.125H24.375V9.37499C24.375 4.20562 20.1693 0 15 0C9.83061 0 5.62499 4.20562 5.62499 9.37499V13.125H4.21874C1.89375 13.125 0 15.0187 0 17.3437V33.2812C0 35.6062 1.89375 37.4999 4.21874 37.4999H17.5687C17.1187 36.0187 16.875 34.4437 16.875 32.8125C16.875 24.975 22.5375 18.45 30 17.1375ZM9.37499 13.125V9.37499C9.37499 6.27374 11.8987 3.74999 15 3.74999C18.1012 3.74999 20.625 6.27374 20.625 9.37499V13.125H9.37499Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 20.625C26.0925 20.625 20.625 26.0925 20.625 32.8125C20.625 39.5325 26.0925 45 32.8125 45C39.5325 45 45 39.5325 45 32.8125C45 26.0925 39.5325 20.625 32.8125 20.625ZM36.9506 36.9506C36.585 37.3162 36.105 37.5 35.625 37.5C35.145 37.5 34.665 37.3162 34.2994 36.9506L31.4869 34.1381C31.1344 33.7875 30.9375 33.3094 30.9375 32.8125V28.125C30.9375 27.09 31.7775 26.25 32.8125 26.25C33.8475 26.25 34.6875 27.09 34.6875 28.125V32.0362L36.9506 34.2994C37.6837 35.0325 37.6837 36.2175 36.9506 36.9506Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakedNfts);
export default __webpack_public_path__ + "static/media/stakedNfts.93374f098c262231b2a1fe889b09a8d2.svg";
export { ForwardRef as ReactComponent };